exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 768px) {\n.success-factor[data-v-55c9aa8e] {\n    max-width: 282px;\n}\n}\n.subtitle[data-v-55c9aa8e] {\n  line-height: 1;\n}\n.icon[data-v-55c9aa8e] {\n  line-height: 1;\n  color: var(--accent);\n}\n.success-factors-row[data-v-55c9aa8e] {\n  display: flex;\n  flex-flow: wrap;\n  margin: 0 -12px;\n}\n.success-factors-row .static-card[data-v-55c9aa8e], .success-factors-row .gift-card[data-v-55c9aa8e] {\n  padding: 0 12px;\n  flex-grow: 1;\n  flex: none;\n}\n[data-v-55c9aa8e] .tns-ovh {\n  overflow: visible;\n}", ""]);

// exports
